import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database";


const firebaseConfig = {
  apiKey: "AIzaSyDC9qKnCd8tDr_hvID4PFqB9dmqUoJ_GwA",
  authDomain: "aistiesteettomyys.firebaseapp.com",
  databaseURL: "https://aistiesteettomyys-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "aistiesteettomyys",
  storageBucket: "aistiesteettomyys.appspot.com",
  messagingSenderId: "396290473228",
  appId: "1:396290473228:web:030b88013bac25691a1d29"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getDatabase(app);

export { auth, app, db }

